var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 13.125C8.625 13.125 13 13.75 14.875 15.625H15.5C15.8452 15.625 16.125 15.3452 16.125 15V11.2106C16.6641 11.0719 17.0625 10.5824 17.0625 10C17.0625 9.41756 16.6641 8.92812 16.125 8.78937V5C16.125 4.65483 15.8452 4.375 15.5 4.375H14.875C13 6.25 8.625 6.875 8.625 6.875H6.125C5.43464 6.875 4.875 7.43464 4.875 8.125V11.875C4.875 12.5654 5.43464 13.125 6.125 13.125H6.75L7.375 16.25H8.625V13.125ZM9.875 7.91325C10.3021 7.82162 10.8297 7.69496 11.3996 7.52733C12.4484 7.21884 13.7812 6.73289 14.875 5.98411V14.0159C13.7812 13.2671 12.4484 12.7812 11.3996 12.4727C10.8297 12.3051 10.3021 12.1784 9.875 12.0868V7.91325ZM6.125 8.125H8.625V11.875H6.125V8.125Z",
    fill: "#C2540A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.cd4e778aa3f80b3f3637ea4cd913f7b6.svg";
export { ForwardRef as ReactComponent };